import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const DotsIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 24 6",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 6),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    children: [/*#__PURE__*/jsxs("g", {
      transform: "translate(1.5 1.5)",
      children: [/*#__PURE__*/jsx("circle", {
        cx: "1.5",
        cy: "1.5",
        r: "1.5",
        stroke: "none"
      }), /*#__PURE__*/jsx("circle", {
        cx: "1.5",
        cy: "1.5",
        r: "2.25"
      })]
    }), /*#__PURE__*/jsxs("g", {
      transform: "translate(10.5 1.5)",
      children: [/*#__PURE__*/jsx("circle", {
        cx: "1.5",
        cy: "1.5",
        r: "1.5",
        stroke: "none"
      }), /*#__PURE__*/jsx("circle", {
        cx: "1.5",
        cy: "1.5",
        r: "2.25"
      })]
    }), /*#__PURE__*/jsxs("g", {
      transform: "translate(19.5 1.5)",
      children: [/*#__PURE__*/jsx("circle", {
        cx: "1.5",
        cy: "1.5",
        r: "1.5",
        stroke: "none"
      }), /*#__PURE__*/jsx("circle", {
        cx: "1.5",
        cy: "1.5",
        r: "2.25"
      })]
    })]
  });
};

export { DotsIcon };
//# sourceMappingURL=dots.js.map
